/*
 * @Author: your name
 * @Date: 2021-09-19 17:12:17
 * @LastEditTime: 2021-09-21 10:48:07
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\plugin\bounty\index.js
 */
// Element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// flex 布局库
// import 'flex.css';
// 组件
import '@/components'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/vue-awesome-swiper.js'

export default {
  async install (Vue) {
    // 设置为 false 以阻止 vue 在启动时生成生产提示。
    // https://cn.vuejs.org/v2/api/#productionTip
    Vue.config.productionTip = false
    // Element
    Vue.use(ElementUI)
    Vue.use(VueAwesomeSwiper)
  }
}
